/* eslint-disable max-len */
import {
  action,
  observable,
} from 'mobx';
import {
  BackendEntity,
  ListBackendEntity,
  ModelOf,
} from 'utils';
import {
  Settings,
} from 'settings';
import {
  BaseBackendStore,
} from '../types';
import {
  bills,
  download,
  payments,
} from './requests';
import {
  DonationDTO,
} from './types';
import {
  BackendStores,
} from '..';
import type {
  SearchObj,
} from '../DoctorsStore/types';

export class DonationStore extends BaseBackendStore {
  @observable private _entityList: DonationDTO[] = [];

  @observable private _donationsList: DonationDTO[] = [];

  @observable filter: SearchObj = {
    filters: [],
  };

  @action public getAll = async (options: any): Promise<DonationDTO[]> => {
    this.filter.filters = options.filters;
    this.filter.search = {
      by: 'any',
      value: options.search,
    };
    if (options.orderBy) {
      this.filter.sort = {
        by: options.orderBy.field,
        type: options.orderDirection.toUpperCase(),
      };
    }
    const response = await this.connections.backend.httpGet(`${bills}?take=${options.pageSize || 10}&page=${options.page + 1}&query=${JSON.stringify(this.filter)}`);
    return response;
  };

  @observable entityList = new ListBackendEntity(
    this,
    '_entityList',
    this.getAll,
  );

  @action public getPayments = async (options: any): Promise<DonationDTO[]> => {
    this.filter.filters = options.filters;
    this.filter.search = {
      by: 'any',
      value: options.search,
    };
    if (options.orderBy) {
      this.filter.sort = {
        by: options.orderBy.field,
        type: options.orderDirection.toUpperCase(),
      };
    }
    const response = await this.connections.backend.httpGet(`${payments}?take=${options.pageSize || 10}&page=${options.page + 1}&query=${JSON.stringify(this.filter)}`);
    return response;
  };

  @observable donationList = new ListBackendEntity(
    this,
    '_paymentsList',
    this.getPayments,
  );

  constructor(
    public parent: BackendStores,
  ) {
    super();
    this.makeObservable();
    this.registerObservableDrivers();
  }

  @observable private _selectedEntity: DonationDTO;

  @observable selectedEntity = new BackendEntity(
    this,
    '_selectedEntity',
    this.getOne,
  );

  @action
  public async create(data: DonationDTO): Promise<void> {
    await this.connections.backend.httpPost(bills, data);
    return Promise.resolve();
  }

  @action
  public async getOne(): Promise<ModelOf<DonationDTO>> {
    // id: string
    return Promise.resolve({} as any);
  }

  @action updateFilter = (item: SearchObj) => {
    this.filter = {
      ...this.filter,
      ...item,
    };
  };

  public download() {
    return `${Settings.config.REACT_APP_BASE_URL + download}?query=${JSON.stringify(this.filter)}&lang=${this.parent.parent.ui.localization.currentLanguage.key}`;
  }
}
